<template>
  <div>
    <div class="d-flex flex-wrap align-items-center justify-content-between mb-1" style="gap: 0.5rem;">
      <div>
        <span class="mr-50">Havuz tipi:</span>
        <b-badge :variant="pool.variant">{{ pool.label }}</b-badge>
        <small class="text-muted ml-50">{{ pool.desc }}</small>
      </div>
      <div v-if="!slotsLocked" class="d-flex" style="gap: 0.5rem;">
        <b-button size="sm" variant="outline-success" @click="onFree">Serbest yap</b-button>
        <b-button size="sm" variant="outline-warning" @click="onLocked">Kilitli yap (eşit dağıt)</b-button>
        <b-button size="sm" variant="outline-secondary" @click="$emit('reset-engines')">Test edilen ayara dön</b-button>
      </div>
    </div>
    <b-alert v-if="slotsLocked" show variant="secondary" class="mb-1">
      <div class="p-50"><small>Slot sınırları {{ slotsLocked }}. Motor aç/kapa her zaman değiştirilebilir (yalnız yeni sinyalleri etkiler).</small></div>
    </b-alert>

    <b-table-simple responsive small class="mb-0">
      <b-thead>
        <b-tr>
          <b-th>Açık</b-th>
          <b-th>Motor</b-th>
          <b-th style="width: 120px;">Ayrılmış (min)</b-th>
          <b-th style="width: 120px;">Üst sınır (max)</b-th>
          <b-th>Test edilen</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr v-for="e in keys" :key="e" :class="{ 'text-muted': !eng(e).enabled }">
          <b-td><b-form-checkbox :checked="eng(e).enabled" switch @change="setEngine(e, 'enabled', $event)" /></b-td>
          <b-td>
            <strong>{{ info[e].label }}</strong>
            <b-badge v-if="differs(e)" variant="light-warning" class="ml-50">değişti</b-badge>
            <div><small class="text-muted">{{ info[e].desc }}</small></div>
          </b-td>
          <b-td>
            <b-form-input type="number" size="sm" min="0" :max="value.slotCount" placeholder="0" :value="eng(e).min" :disabled="!!slotsLocked || !eng(e).enabled" @input="setEngine(e, 'min', toInt($event))" />
          </b-td>
          <b-td>
            <b-form-input type="number" size="sm" min="0" :max="value.slotCount" placeholder="sınırsız" :value="eng(e).max" :disabled="!!slotsLocked || !eng(e).enabled" @input="setEngine(e, 'max', toInt($event))" />
          </b-td>
          <b-td><small>{{ testedText(e) }}</small></b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </div>
</template>

<script>
import {
  BBadge, BButton, BAlert, BTableSimple, BThead, BTbody, BTr, BTh, BTd, BFormCheckbox, BFormInput,
} from 'bootstrap-vue'
import {
  ENGINE_KEYS, ENGINE_INFO, POOL_INFO, poolTypeOf, makeFree, makeLocked, cloneDraft,
} from '../fleetFormat'

export default {
  name: 'FleetEngineSlotsEditor',
  components: {
    BBadge, BButton, BAlert, BTableSimple, BThead, BTbody, BTr, BTh, BTd, BFormCheckbox, BFormInput,
  },
  props: {
    value: { type: Object, required: true },            // draft (slotCount + engines)
    tested: { type: Object, default: () => ({}) },      // engines of the tested template
    slotsLocked: { type: String, default: '' },          // reason text when min/max are read-only
  },
  data() {
    return { keys: ENGINE_KEYS, info: ENGINE_INFO }
  },
  computed: {
    pool() { return POOL_INFO[poolTypeOf(this.value.slotCount, this.value.engines)] },
  },
  methods: {
    eng(e) { return this.value.engines[e] || { enabled: false } },
    toInt(v) { return v === '' || v == null ? undefined : parseInt(v, 10) },
    emitEngines(fn) {
      const d = cloneDraft(this.value)
      fn(d.engines)
      this.$emit('input', d)
    },
    setEngine(e, field, v) { this.emitEngines(en => { en[e] = { ...en[e], [field]: v } }) },
    onFree() { this.emitEngines(en => makeFree(en)) },
    onLocked() { this.emitEngines(en => makeLocked(this.value.slotCount, en)) },
    testedText(e) {
      const t = this.tested[e]
      if (!t) return '—'
      if (!t.enabled) return 'kapalı'
      return t.max != null ? `açık · max ${t.max}` : 'açık · sınırsız'
    },
    differs(e) {
      const a = this.eng(e)
      const b = this.tested[e]
      if (!b) return false
      return !!a.enabled !== !!b.enabled || (a.min || 0) !== (b.min || 0) || (a.max == null ? null : a.max) !== (b.max == null ? null : b.max)
    },
  },
}
</script>
